/** 리다이렉트·replace 시 현재 쿼리(UTM 등)를 path에 붙인다. */
export function pathWithQueryString(path: string, query: URLSearchParams | string): string {
  const qs =
    typeof query === 'string'
      ? query.startsWith('?')
        ? query.slice(1)
        : query
      : query.toString();

  if (!qs) return path;
  return path.includes('?') ? `${path}&${qs}` : `${path}?${qs}`;
}

export function pathWithSearchParamsRecord(
  path: string,
  searchParams: Record<string, string | string[] | undefined>,
): string {
  const qs = new URLSearchParams();
  for (const [key, value] of Object.entries(searchParams)) {
    if (Array.isArray(value)) value.forEach((v) => qs.append(key, v));
    else if (value) qs.set(key, value);
  }
  return pathWithQueryString(path, qs);
}
